import React, { useState, useEffect } from "react";
import { fetchProperties } from "../services/api";
import Skeleton from "react-loading-skeleton";
import { Link } from "react-router-dom";
import "react-loading-skeleton/dist/skeleton.css";
import "./Properties.css";
import { formatUrl } from "../utils/config";

const Properties = () => {
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadProperties = async () => {
      try {
        const data = await fetchProperties(0);
        setProperties(data.payload.page.slice(0, 3)); // Only get first 3 properties
      } catch (error) {
        console.error("Error loading properties:", error);
        setProperties([]);
      } finally {
        setLoading(false);
      }
    };

    loadProperties();
  }, []);

  const PropertySkeleton = () => (
    <div className="col-xl-4 col-md-6">
      <div className="project-card style1-1">
        <div className="project-card-img">
          <Skeleton height={300} />
        </div>
        <div className="project-card-details">
          <h4 className="box-title">
            <Skeleton width={200} />
          </h4>
          <Skeleton width={100} height={35} style={{ marginTop: "10px" }} />
        </div>
      </div>
    </div>
  );
  return !loading && properties.length <= 0 ? (
    <></>
  ) : (
    <section className="project-sec space-top space-extra-bottom">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-6 col-lg-7 col-md-8">
            <div className="title-area text-center">
              {/* <span className="sub-title6">OUR PROPERTIES</span> */}
              <h2 className="sec-title">Featured Properties</h2>
            </div>
          </div>
        </div>
        <div className="row gy-4">
          {loading ? (
            [...Array(3)].map((_, index) => <PropertySkeleton key={index} />)
          ) : (
            <>
              {properties.map((property) => (
                <div key={property.id} className="col-xl-4 col-md-6">
                  <div className="project-card style1-1 property-card-hover">
                    <div className="project-card-img">
                      <img
                        src={formatUrl(property.thumbnail)}
                        alt={property}
                        className="w-100"
                        onError={(e) =>
                          (e.target.src = "/assets/img/main/default.jpg")
                        }
                      />
                    </div>
                    <div className="project-card-details" style={{
                      transition: 'all 0.3s ease-in-out'
                    }}>
                      <h4 className="box-title">
                        <Link
                          to={`/properties/${property.id}`}
                          state={{ property: property }}
                          style={{
                            color: 'inherit',
                            textDecoration: 'none',
                            transition: 'color 0.3s ease-in-out'
                          }}
                        >
                          {property.houseNumber} - {property.buildingType}
                        </Link>
                      </h4>
                      <p className="mb-2" style={{
                        transition: 'color 0.3s ease-in-out'
                      }}>
                        <i className="fas fa-map-marker-alt me-2" style={{
                          color: 'inherit'
                        }}></i>
                        {property.estate.name}, Block {property.blockNumber}
                      </p>
                      <div className="property-features mb-3 d-flex flex-wrap gap-2" style={{
                        transition: 'color 0.3s ease-in-out'
                      }}>
                        <span className="me-3">
                          <i className="fas fa-bed me-1"></i> {property.bedRooms} Beds
                        </span>
                        <span className="me-3">
                          <i className="fas fa-toilet me-1"></i> {property.toilets} Baths
                        </span>
                        {property.livingRoom > 0 && (
                          <span className="me-3">
                            <i className="fas fa-couch me-1"></i> {property.livingRoom} Living
                          </span>
                        )}
                        {property.kitchen > 0 && (
                          <span className="me-3">
                            <i className="fas fa-utensils me-1"></i> {property.kitchen} Kitchen
                          </span>
                        )}
                        {property.dianning > 0 && (
                          <span>
                            <i className="fas fa-chair me-1"></i> {property.dianning} Dining
                          </span>
                        )}
                      </div>
                      <Link
                        to={`/properties/${property.id}`}
                        state={{ property: property }}
                        className="th-btn style9"
                        style={{
                          transition: 'all 0.3s ease-in-out'
                        }}
                      >
                        View Details <i className="fas fa-arrow-right ms-1" />
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
              <div className="col-12 text-center mt-4">
                <Link to="/properties" className="th-btn">
                  View All Properties{" "}
                  <i className="fas fa-arrow-right ms-2"></i>
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default Properties;
